module.exports = __webpack_public_path__ + "img/SHFirmwareManage.613a0086.svg";